import { Card } from "antd";
import { IoMdAdd, IoMdReturnRight } from "react-icons/io";
import "./channel-screen.scss";
import Button from "src/libraries/components/button/Button";
import { DetailChannelScreen } from "./detail-channel-screen";
import { useState } from "react";
import { ChannelAdapter } from "./channel-adapter";
import AddModal from "src/libraries/components/add-modal/add-modal";
import LoadingSpinnerScreen from "src/libraries/components/loading-spinner/loading-spinner.screen";
import { Empty, Pagination } from "antd";
import {
  PaymentChannel,
  SelectBankModalProps,
} from "src/libraries/types/channel";

// const gradientColors = [
//   "linear-gradient(to bottom right, #A1C4FD, #C2E9FB)",
//   "linear-gradient(to bottom right, #D4A5A5, #F4C4C4)",
//   "linear-gradient(to bottom right, #BFE6BA, #D4F4D4)",
//   "linear-gradient(to bottom right, #F5E6A5, #FFF4C4)",
//   "linear-gradient(to bottom right, #D9A7C7, #F5D4E4)",
// ];
export const ChannelScreen = () => {
  const {
    loading,
    totalItem,
    currentPage,
    onPageChange,
    isModalVisible,
    showModal,
    handleOk,
    handleCancel,
    handleChange,
    displayData,
    listBank,
  } = ChannelAdapter();
  const [isOpenDetailScreen, setIsOpenDetailScreen] = useState<boolean>(false);
  const [selectedItem, setSelectedItem] = useState<number>(0);
  //const channelData: PaymentChannel[] = [];
  //const listBank: SelectBankModalProps[] = [];
  const handleDetail = (key: string) => {
    console.log(key);
    setSelectedItem(parseInt(key));
    setIsOpenDetailScreen(true);
  };
  const handleCancelDetailScreen = () => {
    setSelectedItem(0);
    setIsOpenDetailScreen(false);
  };
  const fields = [
    {
      name: "accountID",
      type: "text",
      label: "Số tài khoản MB",
      placeholder: "Số tài khoản MB",
      rules: {
        required: "Bắt buộc",
        // pattern: {
        //   value: /^[0-9]{1,11}$/,
        //   message: "Vui lòng nhập số tài khoản từ 9 đến 13 số",
        // },
      },
      isSelect: true,
      selectOptions: listBank,
    },
    {
      name: "channelName",
      type: "text",
      label: "Tên kênh thanh toán",
      placeholder: "Tên kênh thanh toán(in hoa)",
      rules: {
        required: "Bắt buộc",
        // pattern: {
        //   value: /^[A-Z\s]+$/,
        //   message: "Vui lòng nhập Tên in hoa",
        // },
      },
    },
  ];
  return (
    <div>
      {!isOpenDetailScreen && (
        <div className="payment-channel-screen">
          <div className="add-channel">
            <Button
              className="add-button"
              background="#022e45"
              textColor="#FFF"
              borderColor="#022e45"
            >
              <div className="button-content" onClick={() => showModal()}>
                <i>
                  <IoMdAdd color="#fff" size={24} />
                </i>
                <p className="button-text">Thêm kênh</p>
              </div>
            </Button>
          </div>
          <div className="channelContainer">
            {loading ? (
              <LoadingSpinnerScreen className="big" />
            ) : (
              <div>
                {displayData && displayData.length !== 0 && (
                  <div>
                    {Object.entries(displayData).map(([key, value], index) => (
                      <Card
                        onClick={() => handleDetail(key)}
                        hoverable
                        // style={{
                        //   background:
                        //     gradientColors[index % gradientColors.length], // Lặp lại màu
                        // }}
                        style={{
                          background: "#EDF0EE",
                        }}
                        className="channel-card"
                        key={key}
                      >
                        <div className="card-item">
                          <div className="card-left">
                            <div className="account-img">
                              <img
                                alt="Bank logo"
                                loading="lazy"
                                src="https://img.bankhub.dev/rounded/mbbank.png"
                              />
                            </div>
                            <div className="channel-name">
                              {value?.channelName}
                            </div>
                          </div>
                          <div className="card-right">
                            <IoMdReturnRight />
                          </div>
                        </div>
                      </Card>
                    ))}
                    {/* <div className="channel-pagination">
                      <Pagination
                        onChange={onPageChange}
                        align="end"
                        pageSize={4}
                        current={currentPage}
                        total={totalItem}
                        responsive
                      />
                    </div> */}
                  </div>
                )}
                {displayData.length === 0 && <Empty />}
              </div>
            )}
          </div>
          <AddModal
            title="Thêm mới kênh thanh toán"
            isModalVisible={isModalVisible}
            onOk={handleOk}
            onCancel={handleCancel}
            onChange={handleChange}
            fields={fields}
          />
        </div>
      )}
      {isOpenDetailScreen && (
        <DetailChannelScreen
          handleCancel={handleCancelDetailScreen}
          data={displayData[selectedItem]}
        />
      )}
    </div>
  );
};
